import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="mt-8 border-t border-base-200 px-4 py-8 text-center text-sm text-base-content/60">
      <nav className="flex justify-center gap-6">
        <Link className="hover:text-base-content" to="/">
          Portfolio
        </Link>
        <Link className="hover:text-base-content" to="/contact">
          Contact
        </Link>
        <a className="hover:text-base-content" href="https://www.instagram.com/fotografica.ro/" target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
      </nav>
      <p className="mt-4">© {new Date().getFullYear()} fotoGrafica. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
